import { EntityModel } from '@/interfaces'
import {
  ALL_CONTACT_BANNER_BLOCKS_QUERY,
  CREATE_CONTACT_BANNER_BLOCK_MUTATION,
  DELETE_CONTACT_BANNER_BLOCK_MUTATION,
  FORCE_DELETE_CONTACT_BANNER_BLOCK_MUTATION,
  SINGLE_CONTACT_BANNER_BLOCK_QUERY,
  UPDATE_CONTACT_BANNER_BLOCK_MUTATION,
} from './graphql'
import employeeEntity from '@/entities/employee/entity'

const cmsContactBannerBlockModel: EntityModel = {
  name: 'contactBannerBlock',
  namePlural: 'contactBannerBlocks',
  uniqueName: 'cmsContactBannerBlock',
  uniqueNamePlural: 'cmsContactBannerBlocks',
  path: 'cms/blocks/contact_banner_block',
  baseUrl: '/cms/blocks/contact_banner_blocks',
  translationPrefix: 'entities:cmsContactBannerBlock.',
  getDisplayName: (values: any) => {
    return 'Contact Banner Block'
  },
  gql: {
    getAll: ALL_CONTACT_BANNER_BLOCKS_QUERY,
    getSingle: SINGLE_CONTACT_BANNER_BLOCK_QUERY,
    create: CREATE_CONTACT_BANNER_BLOCK_MUTATION,
    update: UPDATE_CONTACT_BANNER_BLOCK_MUTATION,
    delete: DELETE_CONTACT_BANNER_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_CONTACT_BANNER_BLOCK_MUTATION,
  },
  attributes: {
    employee: {
      name: 'employee',
      label: 'entities:cmsContactBannerBlock.attributes.employee.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return employeeEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    email: {
      name: 'email',
      label: 'entities:cmsContactBannerBlock.attributes.email.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'email',
        },
      ],
    },
    phonePrefix: {
      name: 'phonePrefix',
      label: 'entities:cmsContactBannerBlock.attributes.phonePrefix.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    phone: {
      name: 'phone',
      label: 'entities:cmsContactBannerBlock.attributes.phone.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    phone2Prefix: {
      name: 'phone2Prefix',
      label: 'entities:cmsContactBannerBlock.attributes.phone2Prefix.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    phone2: {
      name: 'phone2',
      label: 'entities:cmsContactBannerBlock.attributes.phone2.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsContactBannerBlockModel
